module.exports = __webpack_public_path__ + "static/logo-3a7a0f06f4527ffc8c744ab42dc0ef07.gif";